import { useAtomValue } from "jotai";
import { Group, Rect, Path } from "react-konva";
import type Konva from "konva";
import { zoomAtom } from "../model/state";

type RemoveIconProps = {
  x: number;
  y: number;
  onRemove: () => void;
};

// SVG path commands for the close/X icon
const CLOSE_ICON_PATH_DATA = "M18 6L6 18M6 6L18 18";

export const REMOVE_ICON_SIZE = 20;
export const ICON_PADDING = 2;
export const BOX_SIZE = REMOVE_ICON_SIZE + ICON_PADDING * 2;

export function RemoveIcon({ x, y, onRemove }: RemoveIconProps) {
  const zoom = useAtomValue(zoomAtom);

  // Close/X icon uses a standard 24x24 viewBox. Scale uniformly so the height fits `iconSize`.
  const pathScale = REMOVE_ICON_SIZE / 24;

  // Offsets to center the scaled path within its bounding box.
  const offsetX = (24 * pathScale) / 2;
  const offsetY = (24 * pathScale) / 2;

  const handleClick = (e: Konva.KonvaEventObject<MouseEvent | TouchEvent>) => {
    // Prevent the click from bubbling up and deselecting the artwork
    e.cancelBubble = true;
    onRemove();
  };

  return (
    <Group
      x={x}
      y={y}
      scaleX={1 / zoom}
      scaleY={1 / zoom}
      listening
      onClick={handleClick}
      onTap={handleClick}
    >
      {/* Remove button background - square with rounded corners */}
      <Rect
        x={-BOX_SIZE / 2}
        y={-BOX_SIZE / 2}
        width={BOX_SIZE}
        height={BOX_SIZE}
        cornerRadius={4}
        fill="white"
        shadowColor="rgba(0, 0, 0, 0.15)"
        shadowBlur={4}
        shadowOffsetY={2}
      />

      {/* Close/X icon rendered with Konva.Path */}
      <Path
        x={-offsetX}
        y={-offsetY}
        data={CLOSE_ICON_PATH_DATA}
        scaleX={pathScale}
        scaleY={pathScale}
        stroke="#C10007"
        strokeWidth={2}
        lineCap="round"
        lineJoin="round"
      />
    </Group>
  );
}
